<template>
  <v-form
    ref="form"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs6
          md4>
          <v-text-field
            v-model.trim="tank.testVendThreshold"
            :counter="6"
            :rules="rules.required.concat(rules.range0_600)"
            :label="`${ $t('Test vend') + ' (' + [ options.volumeUnits[systemSettings.volumeUnit || 0].desc ] + ')' }`"
            data-testId="text-field-Test-vend"
            class="dover-input"/>
        </v-flex>
        <v-flex
          xs6
          md4>
          <v-text-field
            v-model.trim="tank.lossesAverageTime"
            :counter="6"
            :rules="rules.required.concat(rules.range0_100)"
            :label="`${ $t('Avarage time ({0})', [ $t('hour') ]) }`"
            data-testId="text-field-Avarage-time"
            mask="#####"
            class="dover-input"/>
        </v-flex>
        <v-flex
          xs6
          md4/>
        <v-flex
          xs6
          md4>
          <v-text-field
            v-model="tank.lossesWarningThreshold"
            :counter="6"
            :rules="rules.required.concat(rules.warning)"
            :label="`${ $t('Loss warning') + ' (' + [ options.volumeUnits[systemSettings.volumeUnit || 0].desc ] + '/' + $t('hour') + ')' }`"
            data-testId="text-field-Loss-warning"
            class="dover-input"/>
        </v-flex>
        <v-flex
          xs6
          md4>
          <v-text-field
            v-model="tank.lossesAlarmThreshold"
            :counter="6"
            :rules="rules.required.concat(rules.range0_600)"
            :label="`${ $t('Loss alarm') + ' (' + [ options.volumeUnits[systemSettings.volumeUnit || 0].desc ] + '/' + $t('hour') + ')' }`"
            data-testId="text-field-Loss-alarm"
            class="dover-input"/>
        </v-flex>
        <v-flex
          xs6
          md4>
          <v-text-field
            v-model.trim="tank.unaccountedDailyAlarmThreshold"
            :counter="6"
            :rules="rules.required.concat(rules.perc)"
            :label="`${ $t('Unaccounted variance (%)') }`"
            data-testId="text-field-Unaccounted-variance"
            class="dover-input"/>
        </v-flex>
        <v-flex
          xs12
          md12
          text-xs-right>
          <hr>
          <v-btn
            :disabled="!isValidationOk || !Maglink.IsAdminUser()"
            data-testId="btn-Save"
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="saveTank">
            {{ $t('Save') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: false,
    reconciliation: {
      testVendVolume: 12,
      theftVolume: 15,
      averageTime: 23,
      lossWarningVolume: 50,
      lossAlarmVolume: 80,
      unaccountedVariance: 10
    },
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      perc: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 100) ],
      warning: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 600) ],
      range0_600: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 600) ],
      range0_100: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 100) ]
    }
  }),
  watch: {
    'reconciliation.lossWarningVolume' (newVal, oldVal) {
      this.alarmCheck()
    },
    'reconciliation.lossAlarmVolume' (newVal, oldVal) {
      this.alarmCheck()
    }
  },
  mounted () {
  },
  methods: {
    alarmCheck () {
      let item = this.reconciliation

      this.rules.warning = this.rules.required.concat(Vue.prototype.Maglink.RulesRange(item.lossWarningVolume, 1, item.lossAlarmVolume))
      this.$refs.form.validate()
    },
    cyclesCheck () {
      let item = this.calibration.cycles

      this.rules.requiredCycle = this.rules.required.concat(Vue.prototype.Maglink.RulesRange(item.required, 1, item.max))
      this.$refs.form.validate()
    },
    saveTank (event) {
      if (this.$refs.form.validate()) {
        let item = this.tank
        item.testVendThreshold = item.testVendThreshold * 1
        item.theftThreshold = item.theftThreshold * 1
        item.lossesAverageTime = item.lossesAverageTime * 1
        item.lossesWarningThreshold = item.lossesWarningThreshold * 1
        item.lossesAlarmThreshold = item.lossesAlarmThreshold * 1
        item.unaccountedDailyAlarmThreshold = item.unaccountedDailyAlarmThreshold * 1

        this.isValidationOk = true
        this.$emit('tankSaved', this.tank.tankNumber)
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.$t('Tank ACR settings') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
